import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "zoom--sprite",
  "use": "zoom--sprite-usage",
  "viewBox": "0 0 31 31",
  "content": "<symbol viewBox=\"0 0 31 31\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"zoom--sprite\">\n<path d=\"M16.9375 2H28.6716V13.7347\" stroke-width=\"3\" />\n<path d=\"M28.668 16.9355L28.668 28.6702L16.9338 28.6702\" stroke-width=\"3\" />\n<path d=\"M13.7344 28.6699L2.00025 28.6699L2.00026 16.9353\" stroke-width=\"3\" />\n<path d=\"M2 13.7344L2 1.99972L13.7341 1.99972\" stroke-width=\"3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol